import { setZoom } from "../../Store/reducers/fabriccontrolsSlice";
import { setDimensions } from "../../Store/reducers/pixiCanvasSlice";

export const useZoomControls = ({
                                    dispatch,
                                    zoom,
                                    fabricCanvas,
                                    activeTab,
                                    pixiCanvas,
                                }) => {
    let animationFrameId = null; 

    const handleZoom = (relativeZoom) => {
        dispatch(setZoom(relativeZoom));

        if (fabricCanvas  && activeTab !== "previewMockup") {
            const center = new fabric.Point(
                fabricCanvas.getWidth() / 2,
                fabricCanvas.getHeight() / 2
            );
            fabricCanvas.zoomToPoint(center, relativeZoom);
            fabricclampViewport(fabricCanvas);
        } else if (pixiCanvas) {
             console.log("vghjy ",pixiCanvas?.screen?.width)
            const { width: screenWidth, height: screenHeight } = pixiCanvas.screen;
            const cameraContainer = pixiCanvas.cameraContainer;
            const centerX = screenWidth / 2;
            const centerY = screenHeight / 2;

            // Use the current scale as the starting zoom.
            const previousZoom = cameraContainer.scale.x;
            // Calculate the ratio change.
            const ratio = relativeZoom / previousZoom;

            // Adjust the pivot relative to the screen center.
            cameraContainer.pivot.set(
                centerX + (cameraContainer.pivot.x - centerX) * ratio,
                centerY + (cameraContainer.pivot.y - centerY) * ratio
            );
            cameraContainer.scale.set(relativeZoom, relativeZoom);

          
            clampPivot(cameraContainer, screenWidth, screenHeight);
            dispatch(setDimensions({ width: screenWidth, height: screenHeight }));

           
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
            animationFrameId = requestAnimationFrame(() => {
                pixiCanvas.render();
            });
        }
    };

    const zoomIn = () => {
        const newZoom = zoom + 0.1;
        handleZoom(newZoom);
    };

    const zoomOut = () => {
        const newZoom = zoom - 0.1;
        if (newZoom <= 0.3) return;
        handleZoom(newZoom);
    };

    return { zoomIn, zoomOut };
};

export const clampPivot = (cameraContainer, screenWidth, screenHeight) => {
    const scale = cameraContainer.scale.x;
    const visibleWidth = screenWidth / scale;
    const visibleHeight = screenHeight / scale;
    const halfVisibleX = visibleWidth / 2;
    const halfVisibleY = visibleHeight / 2;
    const contentWidth = screenWidth;
    const contentHeight = screenHeight;

    if (visibleWidth >= contentWidth) {
        cameraContainer.pivot.x = contentWidth / 2;
    } else {
        cameraContainer.pivot.x = Math.max(
            halfVisibleX,
            Math.min(cameraContainer.pivot.x, contentWidth - halfVisibleX)
        );
    }
    if (visibleHeight >= contentHeight) {
        cameraContainer.pivot.y = contentHeight / 2;
    } else {
        cameraContainer.pivot.y = Math.max(
            halfVisibleY,
            Math.min(cameraContainer.pivot.y, contentHeight - halfVisibleY)
        );
    }
};

export function fabricclampViewport(canvas) {
    const zoom = canvas.getZoom();
    const canvasWidth = canvas.getWidth();
    const canvasHeight = canvas.getHeight();
    let vpt = canvas.viewportTransform;

    if (zoom <= 1) {
      // When zoomed out, center the canvas content.
      vpt[4] = (canvasWidth - canvasWidth * zoom) / 2;
      vpt[5] = (canvasHeight - canvasHeight * zoom) / 2;
    } else {
      // When zoomed in, limit panning.
      const minX = canvasWidth - canvasWidth * zoom;
      const minY = canvasHeight - canvasHeight * zoom;
      const maxX = 0;
      const maxY = 0;
      if (vpt[4] > maxX) vpt[4] = maxX;
      if (vpt[4] < minX) vpt[4] = minX;
      if (vpt[5] > maxY) vpt[5] = maxY;
      if (vpt[5] < minY) vpt[5] = minY;
    }
    canvas.setViewportTransform(vpt);
  }

